module.exports = "<div class=\"row text-center\" style=\"margin:0;\">\r\n  <h4 class=\"modal-heading modal-heading-{{alertType}}\">{{title}}</h4>\r\n    <mat-dialog-content>\r\n      <p>\r\n        {{message}}\r\n      </p>\r\n    </mat-dialog-content>\r\n    <button class=\"btn btn-danger\" mat-dialog-close><span>OK</span></button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/user-agent-dialog/user-agent-dialog.component.html
// module id = ../../../../../src/app/component/user-agent-dialog/user-agent-dialog.component.html
// module chunks = main